import { createContext, useContext, type ReactNode } from 'react';
import type { ConfiguratorPreviewContext } from '../preview-context';

/**
 * Exposes the mount-time webshop / preview context to deep-nested views
 * (FileUpload needs the cloud base URL + customer + component id for
 * uploads; future Webservice / ProductAttribute views will read host
 * config here too). Read-only — once the configurator boots, the
 * context is frozen for that instance's lifetime.
 *
 * Pure tunnel from ConfiguratorRoot's `preview` prop to the leaf views;
 * no internal state, no derivations.
 */
const WebshopContext = createContext<ConfiguratorPreviewContext | undefined>(undefined);

export function WebshopProvider({
    preview,
    children,
}: {
    preview: ConfiguratorPreviewContext | undefined;
    children: ReactNode;
}) {
    return <WebshopContext.Provider value={preview}>{children}</WebshopContext.Provider>;
}

export function useWebshopContext(): ConfiguratorPreviewContext | undefined {
    return useContext(WebshopContext);
}
